<div class="mat-dialog-containers">
  <div mat-dialog-title class="mat-dialog-title">
    <img style="width: 16rem;" src="assets/imagenes/logo-coomeva.webp">
</div>
<div style="
  padding: 24px;
  text-align: center;
  color: #444;
  word-wrap: break-word;
  white-space: normal;
">
  <p style="margin-bottom: 16px; font-weight: 500;">Apreciado(a) Asesor(a),</p>
  <p style="color: #555;">
    El/la usuario(a) se encuentra afiliado(a) en un programa en el que no es necesario realizar solicitudes de autorización.
  </p>
</div>

<div style="text-align: center; padding-bottom: 16px;">
  <button mat-button (click)="onClose()" style="font-weight: bold; border: none; background: none; padding: 0;">ACEPTAR</button>
</div>

